import React__default from 'react';
import { MenuItemCore } from '../shared/components/MenuItem.mjs';
import { Typography } from './Typography.mjs';

const MenuItem = (props)=>{
    return /*#__PURE__*/ React__default.createElement(MenuItemCore, {
        ...props,
        TypographyComponent: Typography
    });
};

export { MenuItem };
//# sourceMappingURL=MenuItem.mjs.map
